import { request } from './helpers/request'

export const prepareWebAuthnRegistration = () =>
  request({
    url: '/users/mfa/webauthn/register',
    method: 'GET',
  }).then((response) => {
    if (response.status === 200) {
      return Promise.resolve(response.data)
    }
    return Promise.reject(new Error(response.data.code))
  })
